import React from 'react';

interface LoadingOverlayProps {
    isVisible: boolean;
    message?: string;
    subMessage?: string;
}

export const LoadingOverlay: React.FC<LoadingOverlayProps> = ({
                                                                  isVisible,
                                                                  message = 'Generating files...',
                                                                  subMessage = 'Please wait while we prepare your download'
                                                              }) => {
    if (!isVisible) return null;

    return (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 backdrop-blur-sm">
            <div
                className="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl p-8 max-w-sm mx-4 text-center transform animate-fade-in">
                {/* Cute animated loader */}
                <div className="relative w-20 h-20 mx-auto mb-6">
                    {/* Outer spinning ring */}
                    <div className="absolute inset-0 rounded-full border-4 border-blue-200 dark:border-blue-900"></div>
                    <div
                        className="absolute inset-0 rounded-full border-4 border-transparent border-t-blue-600 animate-spin"></div>

                    {/* Inner pulsing circle */}
                    <div
                        className="absolute inset-3 rounded-full bg-blue-100 dark:bg-blue-900/50 animate-pulse flex items-center justify-center">
                        {/* Document icon */}
                        <svg
                            className="w-8 h-8 text-blue-600 dark:text-blue-400"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={1.5}
                                d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                            />
                        </svg>
                    </div>
                </div>

                {/* Bouncing dots */}
                <div className="flex justify-center gap-1.5 mb-4">
                    <div className="w-2 h-2 bg-blue-600 rounded-full animate-bounce"
                         style={{animationDelay: '0ms'}}></div>
                    <div className="w-2 h-2 bg-blue-600 rounded-full animate-bounce"
                         style={{animationDelay: '150ms'}}></div>
                    <div className="w-2 h-2 bg-blue-600 rounded-full animate-bounce"
                         style={{animationDelay: '300ms'}}></div>
                </div>

                {/* Message */}
                <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
                    {message}
                </h3>
                <p className="text-sm text-gray-500 dark:text-gray-400">
                    {subMessage}
                </p>
            </div>
        </div>
    );
};

export default LoadingOverlay;
